import { useMutation } from '@tanstack/react-query';
import { PermissionsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function usePermissionsControllerCreatePermissionMutation(options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useMutation({
        mutationKey: ['permissionsControllerCreatePermission', accessControlScope],
        mutationFn: async (args) => {
            const api = new PermissionsApi(accessControlConfig);
            return api.permissionsControllerCreatePermission(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=usePermissionsControllerCreatePermissionMutation.js.map